export default __webpack_public_path__ + "static/media/bt4.9b5692b0.jpeg";